import { buildData } from '../../../src/utils/stock'
export const getters = {
    getStockList: state => state.stockList,
    getTrendingStockList: state => state.stockTrendingList,
    getTrendingStockTopThreeList: state => state.stockTrendingList.filter((_, index) => {
        return index < 3
    }),
    getStockQuote: state => state.stockQuote,
    showChartModal: state => state.isDisplayChartModal,
    getChartData: state => state.chartData,
    getStockFundQuote: state => state.stockFundQuote,
    getStockShareholder: state => state.stockShareholder,
    getStockPeriod: state => state.stockPeriod,
    getStockNav: state => state.stockNav,
    getStockNav1D: state => state.stockNav1D,
    getStocks: state => state.stocks,
    getStockCurrentPeriod: state => state.stockCurrentPeriod,
    getStockCurrentUnitType: state => state.stockCurrentUnitType,
    getFinancialCardByCardName: (state) => ({ securityID, fields = [] }) => {
        if (!securityID) {
            return
        }
        if (state.stocks.hasOwnProperty(securityID)) {
            return buildData(fields, state.stocks[securityID])
        } else {
            // return expected object.
            return {
                qoq: {},
                yoy: {}
            }
        }
    },
    getStockShareToFriend: (state) => ({ securityID }) => {

        if (!securityID || !state.stocks[securityID]) {
            return
        }

        let arrData = state.stocks[securityID].data
        let lastQ = arrData[arrData.length - 1]
        let present = state.stocks[securityID].present
        return {
            card_value: present.Close || '',
            card_date: present.Date || '',
            close_price: present.Close || '',
            dividend_value: present.DividendYield || '',
            eps: lastQ.EarningPerShare || '',
            eps_growth: lastQ.EarningPerShareYoY || '',
            pe_value: present.PriceEarningRatio || '',
            pbv_value: present.PriceBookValue || ''
        }
    },
    getStockFilter: state => state.stockFilter,
    getStockCategories: state => state.stockCategories,
    getStockFollowing: state => state.stockFollowing,
    getStockTimestamp1D: state => state.stockTimestamp1D
}
  